import { render, staticRenderFns } from "./IUpTriangle.vue?vue&type=template&id=3e8a28e3&scoped=true&"
import script from "./IUpTriangle.vue?vue&type=script&lang=js&"
export * from "./IUpTriangle.vue?vue&type=script&lang=js&"
import style0 from "./IUpTriangle.vue?vue&type=style&index=0&id=3e8a28e3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a28e3",
  null
  
)

export default component.exports